import * as React from 'react';
import {
  Modal,
  StackLayout,
  ParagraphText,
  StackItem,
  HeadingText,
  Button,
} from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';
import { useStaticAsset } from '@leagueplatform/asset-config';
import { useNavigate } from 'react-router-dom';
import { HIGHMARK_COMMON_ASSET_KEYS } from 'types/highmark-common.types';
import { APP_MANAGED_ROUTES } from 'common/app-managed-routes';

interface SignoutModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const SignoutModal: React.FC<SignoutModalProps> = ({
  isOpen,
  onClose,
}) => {
  const navigate = useNavigate();
  const { formatMessage } = useIntl();

  const signoutIcon = useStaticAsset(
    HIGHMARK_COMMON_ASSET_KEYS.SIGNOUT_ICON,
  ) as string;

  const handleSignout = () => {
    navigate(APP_MANAGED_ROUTES.SIGN_OUT);
    onClose();
  };

  return (
    <Modal.Root open={isOpen} onOpenChange={onClose}>
      <Modal.Content
        showCloseButton={false}
        css={{
          '.GDS-modal': {
            maxWidth: '695px',
            borderRadius: '0px',
          },
        }}
      >
        <StackLayout
          horizontalAlignment="center"
          css={{ width: '100%', textAlign: 'center' }}
        >
          <StackLayout horizontalAlignment="stretch">
            <StackItem
              horizontalAlignment="start"
              css={{ width: '100%', alignItems: 'center' }}
            >
              <img src={signoutIcon} alt="signout icon" />{' '}
              <HeadingText
                level="3"
                size="xl"
                css={{
                  color: '$onSurfaceTextPrimary',
                  fontSize: '24px',
                  marginTop: '$one',
                  letterSpacing: '0px',
                }}
              >
                {formatMessage({ id: 'SIGNOUT_SUBTITILE' })}
              </HeadingText>
              <ParagraphText
                css={{
                  color: '$onSurfaceTextPrimary',
                  marginTop: '$one',
                  marginBottom: '$one',
                }}
              >
                {formatMessage({ id: 'SIGNOUT_DESCRIPTION' })}
              </ParagraphText>
              <StackLayout horizontalAlignment="center" css={{ width: 'auto' }}>
                <Button
                  color="secondary"
                  css={{
                    width: '280px',
                    marginTop: '$two',
                    height: '56px',
                    marginBottom: '$threeQuarters',
                    '.GDS-c-PJLV': {
                      margin: 'auto',
                    },
                  }}
                  rel="noreferrer noopener"
                  destructive
                  onClick={handleSignout}
                >
                  {formatMessage({ id: 'SIGN_OUT' })}
                </Button>
                <Button priority="tertiary" quiet onClick={onClose}>
                  {formatMessage({ id: 'STAY_SIGNED_IN' })}
                </Button>
              </StackLayout>
            </StackItem>
          </StackLayout>
        </StackLayout>
      </Modal.Content>
    </Modal.Root>
  );
};
